import { render, staticRenderFns } from "./nba-list.vue?vue&type=template&id=17446118&scoped=true"
import script from "./nba-list.vue?vue&type=script&lang=js"
export * from "./nba-list.vue?vue&type=script&lang=js"
import style0 from "./nba-list.vue?vue&type=style&index=0&id=17446118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17446118",
  null
  
)

export default component.exports